const statusTranslationKeys = {
  not_yet_started: "not_yet_started",
  in_progress: "in_progress",
  completed: "completed",
  Completed: "completed",
  Updated: "Updated",
  Exported: "Exported",
  Revoked: "Revoked",
  Assigned: "Assigned",
  "Re-submitted": "reSubmitted",
};

const medicineFieldTranslationKeys = {
  purpose: "purpose",
  usedFor: "usedFor",
  petTypes: "petTypes",
  activeIngredients: "activeIngredients",
  category: "category",
  reasoning: "reasoning",
  detection_keywords: "detection_keywords",
  typeOfDamage: "typeOfDamage",
  causeOfDamage: "causeOfDamage",
};

const invoiceLanguageTranslationKeys = {
  english: "english",
  german: "german",
  italian: "italian",
  french: "french",
};

export const translateStatus = (t, status) => {
  const translationKey = statusTranslationKeys[status];
  return t(translationKey || "unknownStatus");
};

export const translateMedicineField = (t, field) => {
  const translationKey = medicineFieldTranslationKeys[field];
  return t(translationKey || "unknownField");
};

export const translateInvoiceLanguage = (t, language) => {
  if (!language) {
    return "";
  }

  const translationKey =
    invoiceLanguageTranslationKeys[String(language).toLowerCase()];
  return t(translationKey || "unknownLanguage");
};
